import Vue from 'vue'
import App from './App.vue'
import router from './router'

import "@/styles/base.css"



// import { http } from '@/utils/http.js';

// import { fmt, loadScript } from '@/utils/common.js';


import './permission' // permission control


Vue.prototype.isMobile = /(iPhone|iPad|Android|IEMobile)/ig.test(navigator.userAgent || '');

Vue.directive('animate', {
  inserted: function (el, binding) {
    // 聚焦元素
    binding.addClass = () => {
      const { top } = el.getBoundingClientRect()
      const h = document.documentElement.clientHeight || document.body.clientHeight;

      if (top < (h - 300)) {
        if (el.className.indexOf(binding.value) == -1) {
          // 初次还未绑定过，则新增类名(注意：下面单引号中间是一个空格！！！)
          el.className = binding.value + ' ' + el.className
        }
        if (binding.addClass) {
          window.removeEventListener('scroll', binding.addClass)
        }
      }
    }
    window.addEventListener('scroll', binding.addClass, true)
    binding.addClass()
  },
  unbind: function (el, binding) {
    if (binding.addClass) {
      window.removeEventListener('scroll', binding.addClass)
    }
  }
})


window.$rootVM = new Vue({
  router,
  data() {
    return {
      eventHub: new Vue(),
      mobile: false,
    }
  },
  render: h => h(App)
}).$mount('#app')













